import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { pluck } from '../../../../store.decorator';
import { PayloadAction } from '../../../../store.model';
import { ChatStatusService } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { SendMessage, sendMessageResult } from './send-message.action';

export const sendMessageEpic = (
    action: Observable<PayloadAction<ActionType, SendMessage>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, SendMessage>> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCD__SEND_MESSAGE),
        mergeMap((act: PayloadAction<ActionType, SendMessage>) => {
            const rootState = pluck<TeamschatDialogState>(
                state.value,
                act.storePath,
            );
            const statusService =
                deps.injector.get<ChatStatusService>(ChatStatusService);

            return of(null).pipe(
                tap(() => {
                    void statusService.sendMessage(
                        { msftChatThreadId: rootState.chat.msftChatThreadId },
                        act.payload.message,
                    );
                }),
                map(() => {
                    return sendMessageResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
